import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Column, DataTableInput, DataTableOutput, Order, Search } from "@core/models/datables";
import { environment } from "environments/environment";
import { Regulation, RegulationDetail } from "../models";
import { RegulationSearch } from "../models/regulation-search";
import { TranslateService } from "@ngx-translate/core";

@Injectable({ providedIn: "root" })
export class RegulationService {
  private lang: string = this._translateService.currentLang;
  private columns: Column[];

  constructor(private _http: HttpClient,
    private _translateService: TranslateService) {}

  /**
   * Servicio para obtener las regulacion con las siguientes condicionales de tipo ESTADAR
   * @param regulation
   * @param techFunction
   * @param productCategory
   * @param countries
   * @returns
   */
  getRegulationByCountries(
    regulation: number,
    techFunction: number,
    productCategory: number,
    countries: any
  ) {
    return this._http.post<RegulationDetail[]>(
      `${environment.rydApiUrl}/api/regulation/${regulation}/${techFunction}/${productCategory}`,
      countries
    );
  }

  /**
   * Servicio para obtener Regulaciones Auxiliares con las siguientes condicionales
   * @param regulation
   * @param techFunction
   * @param productCategory
   * @returns
   */
  getRegulationAuxiliar(
    regulation: number,
    techFunction: number,
    productCategory: number,
    countries: any
  ) {
    return this._http.post<RegulationDetail[]>(
      `${environment.rydApiUrl}/api/regulation-aux/${regulation}/${techFunction}/${productCategory}`,
      countries
    );
  }


  getColumns() {
    this._translateService.onLangChange.subscribe(value => {
      if (value) {
        this.lang = value.lang;
      }
    });
    this.columns = [
      {
      data: "name",
      name: "Nombre",
      searchable: true,
      orderable: true,
      search: new Search()
    },
    {
      data:this.lang === "es" ? "typeRegulation.name":"typeRegulation.nameEnglish",
      name: "Tipo",
      searchable: true,
      orderable: true,
      search: new Search()
    },
    {
      data: "status.code",
      name: "status",
      searchable: true,
      orderable: true,
      search: { regex: false, value: "ACT" }
    }
  ]}

  /**
   * Get all Regulations
   * 
   */
  getAllRegulations(page: number, quantity: number, order: Order, searchText: string) {
    const input = this.createDataTableInput(page, quantity, order, searchText);
    return this._http.post<DataTableOutput<Regulation>>(`${environment.rydApiUrl}/api/regulation/index`, input);
  }

  deleteRegulation(id: number, statusId: number) {
    return this._http.put<any>(`${environment.rydApiUrl}/api/regulation/delete/${id}/${statusId}`, null);
  }

  addRegulation(regulation: Regulation) {
    return this._http.post<any>(`${environment.rydApiUrl}/api/regulation`, regulation);
  }

  editRegulation(regulation: Regulation) {
    return this._http.put<Regulation>(`${environment.rydApiUrl}/api/regulation/${regulation.id}`, regulation);
  }
  getAll() {
    return this._http.get<Regulation[]>(`${environment.rydApiUrl}/api/regulation`);

  }


  /**
  * Función que crea una entrada para datatable por medio de parametros
  * @param page Indica el número de página
  * @param quantity Indica la cantidad de unidades a solicitar
  * @param order Indica el orden que tendrá la columna
  * @param searchText Indica el texto que se va a filtrar
  * @returns Devuelve una entrada para datatable
  */
  private createDataTableInput(page: number, quantity: number, order: Order, searchText: string): DataTableInput {
    this.getColumns();
    let input = new DataTableInput();
    input.start = page * quantity;
    input.length = quantity;
    if (searchText !== '') {
      input.search.regex = true;
      input.search.value = searchText;
    }
    if (order) {
      input.order.push(order);
    }
    input.columns = this.columns;
    return input;
  }
}
